import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { validatePassword } from 'utils/passwordValidator';
import { PASSWORD_REQUIREMENTS_KEY } from 'utils/passwordValidatorConstants';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import ResetPasswordField from '../Fields/ResetPasswordField/ResetPasswordField';
import LoadingButton from '../LoadingButton';
import styles from './style.css';

const validate = values => {
  let errors = {};
  errors = validatePassword(values.newPassword, values.confPassword);
  return {
    newPassword: errors.password,
    confPassword: errors.password_confirmation,
  };
};

const ResetPasswordForm = class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  toggleEye = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  render() {
    const { handleSubmit, valid } = this.props;
    return (
      <div className="col-md-12 no-padding">
        <form onSubmit={handleSubmit}>
          <p className={styles['description-reset-password']}>
            <Trans id={PASSWORD_REQUIREMENTS_KEY} />
          </p>
          <div className={`${styles['password-container']}`}>
            <I18n>
              {({ i18n }) => (
                <Field
                  component={ResetPasswordField}
                  name="newPassword"
                  type={this.state.showPassword ? 'text' : 'password'}
                  placeholder={i18n._(t`New Password`)}
                  autoCorrect="off"
                  maxLength="40"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              )}
            </I18n>
            <div className={`${styles.eyes}`} onClick={this.toggleEye}>
              {this.state.showPassword ? (
                <span className="glyphicon glyphicon-eye-open" />
              ) : (
                <span className="glyphicon glyphicon-eye-close" />
              )}
            </div>
          </div>

          <I18n>
            {({ i18n }) => (
              <Field
                component={ResetPasswordField}
                name="confPassword"
                type="password"
                placeholder={i18n._(t`Retype new password`)}
                autoCorrect="off"
                maxLength="40"
                autoCapitalize="off"
                spellCheck="false"
              />
            )}
          </I18n>

          <div className={styles['submit-btn-container']}>
            {this.props.currentlySending ? (
              <LoadingButton />
            ) : (
              <button
                type="submit"
                className={`btn btn-primary center ${styles['submit-btn']}`}
                disabled={!valid}
              >
                {this.props.btnText}
              </button>
            )}
          </div>
        </form>
      </div>
    );
  }
};

ResetPasswordForm.propTypes = {
  dispatch: PropTypes.func,
  onSubmit: PropTypes.func,
  btnText: PropTypes.string,
};

const mapFormValidation = {
  form: 'ResetPasswordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

export default reduxForm(mapFormValidation)(ResetPasswordForm);
